<template>
  <b-modal
      v-bind="$props"
      :id="id"
      ok-variant="danger"
      no-close-on-backdrop
      @cancel="resolvePromise(false)"
      @ok="resolvePromise(true)"
      @hide="resolvePromise && resolvePromise(false)"
  >
    <div>
      <slot>
        <span v-html="options.message"></span>
      </slot>
<!--      {{options.message}}-->
    </div>
    <template #modal-footer="{ ok, cancel, hide }">
      <b-button size="md" variant="primary" @click="ok()">
        OK
      </b-button>
      <b-button size="md" variant="outline-dark" @click="cancel()">
        Cancel
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "confirmation-modal",
  props: {
    id: {default: 'confirmation-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      options: {
        message: null,
      },
      resolvePromise: null,
      rejectPromise: null
    };
  },
  methods: {
    show(options) {
      return new Promise((resolve, reject) => {
        this.options = options;
        this.$bvModal.show(this.id);

        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    hide() {
      this.$bvModal.hide(this.id);
    }
  }
};
</script>

<style scoped lang="scss">
  ::v-deep {
    .modal-body {
      color: var(--neutral-gray-800, #454646);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
    .modal-footer {
      border: none;
    }
  }
</style>
